<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <Form
      :addNewData="openModal"
      @closeModal="closeModal()"
      @submitModal="submitModal()"
      :editMode="editMode"
      :dataEdit="dataEdit"
      :roleData="roleData"
      :fleetData="fleetData"
      :alertData="alertData"
      :title="titleModal"
      :allData="data" />

    <BulkPassChange :openModal="addBulk" @closeModal="closeModal()" />

    <vs-table
      ref="table"
      @selected="handleSelected"
      :max-items="itemsPerPage"
      :data="data">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            id="addButton"
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNew()">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span
              class="ml-2 text-base text-primary"
              id="addButton2"
              @click="addNew()"
              >{{ $t('Add New') }}</span
            >
          </div>
          <!-- Bulk Change password -->
          <div
            id="addButton"
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="bulkChange()">
            <feather-icon icon="EditIcon" svgClasses="h-4 w-4" />
            <span
              class="ml-2 text-base text-primary"
              id="addButton2"
              @click="bulkChange()"
              >{{ $t('Bulk Change Password') }}</span
            >
          </div>
        </div>
        <div
          class="vs-component vs-con-input-label vs-input mb-5 vs-input-primary">
          <v-select
            placeholder="- Fleet Group -"
            style="background: white"
            @input="(x) => (selected_fleet = x.value)"
            :clearable="false"
            :value="getSelectValue(selected_fleet, fleetData)"
            :reduce="(text) => text.value"
            label="text"
            :options="fleetData" />
        </div>
        <!--<vs-select id="selectFleet"  placeholder="- Select -" v-model="selected_fleet" label="Fleet Group" class="cursor-pointer mb-4 mr-4">-->
        <!--<vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in fleetData" />-->
        <!--</vs-select>-->
        <!-- ITEMS PER PAGE -->
        <div class="con-input-search vs-table--search">
          <input
            id="searchUsers"
            v-model="search_name"
            placeholder="Search Name"
            type="text"
            class="input-search vs-table--search-input" /><i
            class="material-icons">
            search
          </i>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="no">{{ $t('NAME') }}</vs-th>
        <vs-th sort-key="id">{{ $t('EMAIL') }}</vs-th>
        <vs-th sort-key="role_name">{{ $t('ROLE') }}</vs-th>
        <!-- <vs-th sort-key="fleet_group">{{ $t('FLEET GROUP') }}</vs-th> -->
        <vs-th sort-key="is_active">{{ $t('STATUS') }}</vs-th>
        <vs-th sort-key="las_login">{{ $t('LAST LOGIN') }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody id="isi_table">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>
            <vs-td :data="data[indextr].email">
              <p class="product-name font-medium">{{ tr.email }}</p>
            </vs-td>
            <vs-td :data="data[indextr].role_name">
              <p class="product-name">{{ tr.role_name }}</p>
            </vs-td>

            <!-- <vs-td :data="data[indextr].fleet_group">
              <p class="product-name">{{ tr.fleet_group }}</p>
            </vs-td> -->
            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.is_active)"
                class="product-order-status">
                {{ statusDescription(tr.is_active) }}
              </vs-chip>
            </vs-td>
            <vs-td
              :data="
                data[indextr].last_login
                  ? data[indextr].last_login.created_at
                  : '-'
              ">
              <p class="product-name">
                {{ tr.last_login ? tr.last_login.created_at : '-' }}
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <template>
      <vs-pagination :total="last_page" v-model="page"></vs-pagination>
    </template>
  </div>
</template>

<script>
import Form from './UsersForm.vue'
import * as REPO from '../../repository/index'
import { getListFleetGroup } from '../../repository/index'
import BulkPassChange from '../components/BulkPassChange.vue'

export default {
  components: {
    BulkPassChange,
    Form,
  },
  beforeRouteLeave(to, from, next) {
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  data() {
    return {
      addBulk: false,
      openModal: false,
      editMode: false,
      titleModal: 'Add New',
      selected: [],
      dataEdit: {},
      fleetData: [],
      data: [],
      roleData: [],
      alertData: [],
      itemsPerPage: 10,
      last_page: 1,
      page: 1,
      search_name: '',
      selected_fleet: '',
      isMounted: false,
      addNewDataSidebar: false,
    }
  },
  watch: {
    page(val) {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.getUser({
        page: val,
        name: this.search_name,
        fleet_group_id: this.selected_fleet,
      })
    },

    selected_fleet(val) {
      if (val != '') {
        this.$vs.loading({
          container: '#isi_table',
          scale: 1,
        })
        this.getUser({
          page: this.page,
          name: this.search_name,
          fleet_group_id: val,
        })
      } else {
        this.$vs.loading({
          container: '#isi_table',
          scale: 1,
        })
        this.getUser({ page: this.page, name: this.search_name })
      }
    },
    search_name(val) {
      if (val.length > 2) {
        this.$vs.loading({
          container: '#isi_table',
          scale: 1,
        })
        this.getUser({
          page: this.page,
          name: val,
          fleet_group_id: this.selected_fleet,
        })
      }
      if (val == '') {
        this.$vs.loading({
          container: '#isi_table',
          scale: 1,
        })
        this.getUser({ page: this.page, fleet_group_id: this.selected_fleet })
      }
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  methods: {
    bulkChange() {
      this.addBulk = true
    },
    addNew() {
      this.editMode = false
      this.titleModal = 'Add New'
      this.dataEdit = {}
      this.openModal = true
    },
    getUser(param) {
      REPO.getListUser(param)
        .then((res) => {
          let tmp = res.data.data.data
          this.last_page = res.data.data.last_page
          tmp.forEach((x) => {
            let cari = this.fleetData.filter((y) => {
              return y.value == x.fleet_group_id
            })
            let cari_role = this.roleData.filter((y) => {
              return y.value == x.role_id
            })
            if (cari_role.length > 0) {
              x.role_name = cari_role[0].text
            } else {
              x.role_name = x.role_id
            }
            if (cari.length > 0) {
              x.fleet_group = cari[0].text
            } else {
              x.fleet_group = x.role_id
            }
          })
          this.data = tmp
          //
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close('#isi_table > .con-vs-loading')
        })
        .catch((err) => {
          //
        })
    },
    getData() {
      REPO.getListRole().then((res) => {
        let role = res.data.data
        this.roleData = []
        role.forEach((x) => {
          this.roleData.push({
            text: x.role_name,
            value: x.id,
          })
        })
        REPO.getListFleetGroup().then((res_fleet) => {
          let fleet = res_fleet.data.data
          this.fleetData = []
          fleet.forEach((x) => {
            this.fleetData.push({
              text: x.fleet_group_name,
              value: x.id,
            })
          })
          REPO.getListAlert()
            .then((res_alert) => {
              let alert = res_alert.data.data
              this.alertData = []
              alert.forEach((x) => {
                this.alertData.push({
                  text: x.alert_name,
                  value: x.alert_code,
                })
              })
            })
            .catch((err) => {
              this.alertData = []
            })
          this.getUser({ page: 1 })
        })
      })
    },
    statusDescription(val) {
      if (val == 1) {
        return 'Active'
      } else {
        return 'Non Active'
      }
    },
    handleSelected(tr) {
      this.editMode = true
      this.titleModal = 'Update Data'
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.openModal = true
    },
    closeModal() {
      this.openModal = false
      this.addBulk = false
    },
    submitModal() {
      this.openModal = false
      this.getData()
    },
    getStatusColor(status) {
      if (status == '0') return 'danger'
      if (status == '1') return 'success'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
          obj[key] =
            fields[key].stringValue ||
            fields[key].integerValue ||
            fields[key].doubleValue
        }
        return obj
      })
      return formattedData
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })
    this.isMounted = true
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
